import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetFindingAndRecommendationDetailsAsync,
  IFindingAndRecommendationDetails,
} from "../../api/IFindingAndRecommendation";
import { RootState } from "../store";

export interface FindingAndRecommendationState {
  fetchStatus: string;
  findingAndRecommendation?: IFindingAndRecommendationDetails;
}

const initialState: FindingAndRecommendationState = {
  fetchStatus: "Loading...",
  findingAndRecommendation: undefined,
};

export const loadFindingAndRecommendationAsync = createAsyncThunk(
  "findingAndRecommendation/load",
  async (taskId: string) => {
    const response = await GetFindingAndRecommendationDetailsAsync(taskId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const findingAndRecommendationSlice = createSlice({
  name: "findingAndRecommendation",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadFindingAndRecommendationAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadFindingAndRecommendationAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.findingAndRecommendation = action.payload;
      });
  },
});

export const selectFindingAndRecommendation = (state: RootState) =>
  state.findingAndRecommendationReducer;

export default findingAndRecommendationSlice.reducer;
